/* Do not edit! Autogenerated from ~/ui/fw.css with ~/ui/fw.generate.ts */


import type { Trim } from "type-fest"

export type Color = 'color-accent' | 'color-accent-ghost' | 'color-accent-solid' | 'color-blue' | 'color-blue-deep-ghost' | 'color-blue-deep-solid' | 'color-blue-ghost' | 'color-blue-solid' | 'color-default' | 'color-default-ghost' | 'color-default-solid' | 'color-destructive' | 'color-destructive-ghost' | 'color-destructive-solid' | 'color-green' | 'color-green-deep-ghost' | 'color-green-deep-solid' | 'color-green-ghost' | 'color-green-solid' | 'color-ochre' | 'color-ochre-deep-ghost' | 'color-ochre-deep-solid' | 'color-ochre-ghost' | 'color-ochre-solid' | 'color-pink' | 'color-pink-deep-ghost' | 'color-pink-deep-solid' | 'color-pink-ghost' | 'color-pink-solid' | 'color-primary' | 'color-primary-ghost' | 'color-primary-solid' | 'color-purple' | 'color-purple-deep-ghost' | 'color-purple-deep-solid' | 'color-purple-ghost' | 'color-purple-solid' | 'color-red' | 'color-red-deep-ghost' | 'color-red-deep-solid' | 'color-red-ghost' | 'color-red-solid' | 'color-yellow' | 'color-yellow-deep-ghost' | 'color-yellow-deep-solid' | 'color-yellow-ghost' | 'color-yellow-solid'
export type Fill = boolean
export type Font = 'font-caption' | 'font-caption-emphasized' | 'font-card-title' | 'font-large-section-heading' | 'font-monospace' | 'font-page-heading' | 'font-radio' | 'font-secondary' | 'font-section-heading' | 'font-small' | 'font-subsection-heading' | 'font-title' | 'font-title-large'
export type Layout = 'layout-grid' | 'layout-row' | 'layout-row-reverse' | 'layout-stack'
export type Align = 'align-center' | 'align-start' | 'align-stretch'
export type Justify = 'justify-center' | 'justify-end' | 'justify-start' | 'justify-stretch'
export type Padding = 'padding-large' | 'padding-modal' | 'padding-page' | 'padding-small'
export type Shape = 'shape-card' | 'shape-circle' | 'shape-field' | 'shape-field-full' | 'shape-field-grow' | 'shape-field-minimal' | 'shape-modal' | 'shape-pill' | 'shape-square'
export type Variable = '--bleed-block-end' | '--bleed-block-start' | '--bleed-inline-end' | '--bleed-inline-start' | '--block-gap' | '--block-size' | '--block-size-12' | '--block-size-16' | '--block-size-20' | '--block-size-24' | '--block-size-32' | '--block-size-4' | '--block-size-40' | '--block-size-48' | '--block-size-64' | '--block-size-8' | '--block-size-96' | '--color-100' | '--color-150' | '--color-200' | '--color-250' | '--color-300' | '--color-350' | '--color-400' | '--color-450' | '--color-50' | '--color-500' | '--color-550' | '--color-600' | '--color-650' | '--color-700' | '--color-750' | '--color-800' | '--color-850' | '--color-900' | '--color-950' | '--color-background' | '--color-background-150' | '--color-background-200' | '--color-background-250' | '--color-background-300' | '--color-background-350' | '--color-background-400' | '--color-background-450' | '--color-background-50' | '--color-background-500' | '--color-background-550' | '--color-background-600' | '--color-background-650' | '--color-background-750' | '--color-background-active' | '--color-background-editing' | '--color-background-hover' | '--color-background-pressed' | '--color-background-selected' | '--color-default-100' | '--color-default-150' | '--color-default-200' | '--color-default-250' | '--color-default-300' | '--color-default-350' | '--color-default-400' | '--color-default-450' | '--color-default-50' | '--color-default-500' | '--color-default-550' | '--color-default-600' | '--color-default-650' | '--color-default-700' | '--color-default-750' | '--color-default-800' | '--color-default-850' | '--color-default-900' | '--color-default-950' | '--color-focus' | '--color-foreground' | '--color-foreground-100' | '--color-foreground-150' | '--color-foreground-200' | '--color-foreground-50' | '--color-foreground-500' | '--color-foreground-550' | '--color-foreground-650' | '--color-foreground-700' | '--color-foreground-750' | '--color-foreground-800' | '--color-foreground-850' | '--color-foreground-900' | '--color-foreground-950' | '--color-foreground-active' | '--color-foreground-editing' | '--color-foreground-hover' | '--color-foreground-pressed' | '--color-foreground-selected' | '--color-link' | '--color-link-active' | '--color-link-hover' | '--color-shadow' | '--fade-size' | '--fw-blue-100' | '--fw-blue-150' | '--fw-blue-200' | '--fw-blue-250' | '--fw-blue-300' | '--fw-blue-350' | '--fw-blue-400' | '--fw-blue-450' | '--fw-blue-50' | '--fw-blue-500' | '--fw-blue-550' | '--fw-blue-600' | '--fw-blue-650' | '--fw-blue-700' | '--fw-blue-750' | '--fw-blue-800' | '--fw-blue-850' | '--fw-blue-900' | '--fw-blue-950' | '--fw-gray-100' | '--fw-gray-150' | '--fw-gray-200' | '--fw-gray-250' | '--fw-gray-300' | '--fw-gray-350' | '--fw-gray-400' | '--fw-gray-450' | '--fw-gray-50' | '--fw-gray-500' | '--fw-gray-550' | '--fw-gray-600' | '--fw-gray-650' | '--fw-gray-700' | '--fw-gray-750' | '--fw-gray-800' | '--fw-gray-850' | '--fw-gray-900' | '--fw-gray-950' | '--fw-orange-100' | '--fw-orange-150' | '--fw-orange-200' | '--fw-orange-250' | '--fw-orange-300' | '--fw-orange-350' | '--fw-orange-400' | '--fw-orange-450' | '--fw-orange-50' | '--fw-orange-500' | '--fw-orange-550' | '--fw-orange-600' | '--fw-orange-650' | '--fw-orange-700' | '--fw-orange-750' | '--fw-orange-800' | '--fw-orange-850' | '--fw-orange-900' | '--fw-orange-950' | '--fw-pastel-blue-100' | '--fw-pastel-blue-150' | '--fw-pastel-blue-200' | '--fw-pastel-blue-250' | '--fw-pastel-blue-300' | '--fw-pastel-blue-350' | '--fw-pastel-blue-400' | '--fw-pastel-blue-450' | '--fw-pastel-blue-50' | '--fw-pastel-blue-500' | '--fw-pastel-blue-550' | '--fw-pastel-blue-600' | '--fw-pastel-blue-650' | '--fw-pastel-blue-700' | '--fw-pastel-blue-750' | '--fw-pastel-blue-800' | '--fw-pastel-blue-850' | '--fw-pastel-blue-900' | '--fw-pastel-blue-950' | '--fw-pastel-green-100' | '--fw-pastel-green-150' | '--fw-pastel-green-200' | '--fw-pastel-green-250' | '--fw-pastel-green-300' | '--fw-pastel-green-350' | '--fw-pastel-green-400' | '--fw-pastel-green-450' | '--fw-pastel-green-50' | '--fw-pastel-green-500' | '--fw-pastel-green-550' | '--fw-pastel-green-600' | '--fw-pastel-green-650' | '--fw-pastel-green-700' | '--fw-pastel-green-750' | '--fw-pastel-green-800' | '--fw-pastel-green-850' | '--fw-pastel-green-900' | '--fw-pastel-green-950' | '--fw-pastel-ochre-100' | '--fw-pastel-ochre-150' | '--fw-pastel-ochre-200' | '--fw-pastel-ochre-250' | '--fw-pastel-ochre-300' | '--fw-pastel-ochre-350' | '--fw-pastel-ochre-400' | '--fw-pastel-ochre-450' | '--fw-pastel-ochre-50' | '--fw-pastel-ochre-500' | '--fw-pastel-ochre-550' | '--fw-pastel-ochre-600' | '--fw-pastel-ochre-650' | '--fw-pastel-ochre-700' | '--fw-pastel-ochre-750' | '--fw-pastel-ochre-800' | '--fw-pastel-ochre-850' | '--fw-pastel-ochre-900' | '--fw-pastel-ochre-950' | '--fw-pastel-purple-100' | '--fw-pastel-purple-150' | '--fw-pastel-purple-200' | '--fw-pastel-purple-250' | '--fw-pastel-purple-300' | '--fw-pastel-purple-350' | '--fw-pastel-purple-400' | '--fw-pastel-purple-450' | '--fw-pastel-purple-50' | '--fw-pastel-purple-500' | '--fw-pastel-purple-550' | '--fw-pastel-purple-600' | '--fw-pastel-purple-650' | '--fw-pastel-purple-700' | '--fw-pastel-purple-750' | '--fw-pastel-purple-800' | '--fw-pastel-purple-850' | '--fw-pastel-purple-900' | '--fw-pastel-purple-950' | '--fw-pastel-red-100' | '--fw-pastel-red-150' | '--fw-pastel-red-200' | '--fw-pastel-red-250' | '--fw-pastel-red-300' | '--fw-pastel-red-350' | '--fw-pastel-red-400' | '--fw-pastel-red-450' | '--fw-pastel-red-50' | '--fw-pastel-red-500' | '--fw-pastel-red-550' | '--fw-pastel-red-600' | '--fw-pastel-red-650' | '--fw-pastel-red-700' | '--fw-pastel-red-750' | '--fw-pastel-red-800' | '--fw-pastel-red-850' | '--fw-pastel-red-900' | '--fw-pastel-red-950' | '--fw-pastel-yellow-100' | '--fw-pastel-yellow-150' | '--fw-pastel-yellow-200' | '--fw-pastel-yellow-250' | '--fw-pastel-yellow-300' | '--fw-pastel-yellow-350' | '--fw-pastel-yellow-400' | '--fw-pastel-yellow-450' | '--fw-pastel-yellow-50' | '--fw-pastel-yellow-500' | '--fw-pastel-yellow-550' | '--fw-pastel-yellow-600' | '--fw-pastel-yellow-650' | '--fw-pastel-yellow-700' | '--fw-pastel-yellow-750' | '--fw-pastel-yellow-800' | '--fw-pastel-yellow-850' | '--fw-pastel-yellow-900' | '--fw-pastel-yellow-950' | '--fw-pink-100' | '--fw-pink-150' | '--fw-pink-200' | '--fw-pink-250' | '--fw-pink-300' | '--fw-pink-350' | '--fw-pink-400' | '--fw-pink-450' | '--fw-pink-50' | '--fw-pink-500' | '--fw-pink-550' | '--fw-pink-600' | '--fw-pink-650' | '--fw-pink-700' | '--fw-pink-750' | '--fw-pink-800' | '--fw-pink-850' | '--fw-pink-900' | '--fw-pink-950' | '--fw-red-100' | '--fw-red-150' | '--fw-red-200' | '--fw-red-250' | '--fw-red-300' | '--fw-red-350' | '--fw-red-400' | '--fw-red-450' | '--fw-red-50' | '--fw-red-500' | '--fw-red-550' | '--fw-red-600' | '--fw-red-650' | '--fw-red-700' | '--fw-red-750' | '--fw-red-800' | '--fw-red-850' | '--fw-red-900' | '--fw-red-950' | '--grid-column' | '--inline-gap' | '--inline-size-12' | '--inline-size-128' | '--inline-size-16' | '--inline-size-160' | '--inline-size-208' | '--inline-size-240' | '--inline-size-288' | '--inline-size-32' | '--inline-size-4' | '--inline-size-448' | '--inline-size-48' | '--inline-size-8' | '--inline-size-96' | '--mask-end' | '--mask-padding-inline-end' | '--mask-padding-inline-start' | '--mask-start' | '--padding-block-end' | '--padding-block-start' | '--padding-inline-end' | '--padding-inline-start'
export type Attribute = 'ui-bleed' | 'ui-bleed-block' | 'ui-bleed-inline' | 'ui-block-size' | 'ui-gap' | 'ui-indicate-overflow' | 'ui-inline-size' | 'ui-interactive' | 'ui-line-height' | 'ui-nowrap' | 'ui-overshoot-none' | 'ui-raised' | 'ui-shrinkable' | 'ui-span-all' | 'ui-sunken'

export const fw = {
  color: {
    accent: 'color-accent',
    accentGhost: 'color-accent-ghost',
    accentSolid: 'color-accent-solid',
    blue: 'color-blue',
    blueDeepGhost: 'color-blue-deep-ghost',
    blueDeepSolid: 'color-blue-deep-solid',
    blueGhost: 'color-blue-ghost',
    blueSolid: 'color-blue-solid',
    default: 'color-default',
    defaultGhost: 'color-default-ghost',
    defaultSolid: 'color-default-solid',
    destructive: 'color-destructive',
    destructiveGhost: 'color-destructive-ghost',
    destructiveSolid: 'color-destructive-solid',
    green: 'color-green',
    greenDeepGhost: 'color-green-deep-ghost',
    greenDeepSolid: 'color-green-deep-solid',
    greenGhost: 'color-green-ghost',
    greenSolid: 'color-green-solid',
    ochre: 'color-ochre',
    ochreDeepGhost: 'color-ochre-deep-ghost',
    ochreDeepSolid: 'color-ochre-deep-solid',
    ochreGhost: 'color-ochre-ghost',
    ochreSolid: 'color-ochre-solid',
    pink: 'color-pink',
    pinkDeepGhost: 'color-pink-deep-ghost',
    pinkDeepSolid: 'color-pink-deep-solid',
    pinkGhost: 'color-pink-ghost',
    pinkSolid: 'color-pink-solid',
    primary: 'color-primary',
    primaryGhost: 'color-primary-ghost',
    primarySolid: 'color-primary-solid',
    purple: 'color-purple',
    purpleDeepGhost: 'color-purple-deep-ghost',
    purpleDeepSolid: 'color-purple-deep-solid',
    purpleGhost: 'color-purple-ghost',
    purpleSolid: 'color-purple-solid',
    red: 'color-red',
    redDeepGhost: 'color-red-deep-ghost',
    redDeepSolid: 'color-red-deep-solid',
    redGhost: 'color-red-ghost',
    redSolid: 'color-red-solid',
    yellow: 'color-yellow',
    yellowDeepGhost: 'color-yellow-deep-ghost',
    yellowDeepSolid: 'color-yellow-deep-solid',
    yellowGhost: 'color-yellow-ghost',
    yellowSolid: 'color-yellow-solid'
  },
  font: {
    caption: 'font-caption',
    captionEmphasized: 'font-caption-emphasized',
    cardTitle: 'font-card-title',
    largeSectionHeading: 'font-large-section-heading',
    monospace: 'font-monospace',
    pageHeading: 'font-page-heading',
    radio: 'font-radio',
    secondary: 'font-secondary',
    sectionHeading: 'font-section-heading',
    small: 'font-small',
    subsectionHeading: 'font-subsection-heading',
    title: 'font-title',
    titleLarge: 'font-title-large'
  },
  layout: {
    grid: 'layout-grid',
    row: 'layout-row',
    rowReverse: 'layout-row-reverse',
    stack: 'layout-stack'
  },
  align: {
    center: 'align-center',
    start: 'align-start',
    stretch: 'align-stretch'
  },
  justify: {
    center: 'justify-center',
    end: 'justify-end',
    start: 'justify-start',
    stretch: 'justify-stretch'
  },
  padding: {
    large: 'padding-large',
    modal: 'padding-modal',
    page: 'padding-page',
    small: 'padding-small'
  },
  shape: {
    card: 'shape-card',
    circle: 'shape-circle',
    field: 'shape-field',
    fieldFull: 'shape-field-full',
    fieldGrow: 'shape-field-grow',
    fieldMinimal: 'shape-field-minimal',
    modal: 'shape-modal',
    pill: 'shape-pill',
    square: 'shape-square'
  }
} as const

export type Ui = {
  uiBleed: boolean
  uiBleedBlock: boolean
  uiBleedInline: boolean
  uiBlockSize: '24' | '40' | '48' | '64' | '96'
  uiGap: '0' | '4' | '8' | '12' | '16' | '32' | '48 8' | '48 16' | '64 8'
  uiIndicateOverflow: boolean
  uiInlineSize: '48' | '96' | '128' | '160' | '208' | '240' | '288' | '448'
  uiInteractive: boolean
  uiLineHeight: '16' | '24' | '32'
  uiNowrap: boolean
  uiOvershootNone: boolean
  uiRaised: boolean
  uiShrinkable: boolean
  uiSpanAll: boolean
  uiSunken: boolean
}

export const ui = {
  bleed: true,
  bleedBlock: true,
  bleedInline: true,
  blockSize: {
      '24': '24',
      '40': '40',
      '48': '48',
      '64': '64',
      '96': '96'
    },
  gap: {
      '0': '0',
      '4': '4',
      '8': '8',
      '12': '12',
      '16': '16',
      '32': '32',
      '48 8': '48 8',
      '48 16': '48 16',
      '64 8': '64 8'
    },
  indicateOverflow: true,
  inlineSize: {
      '48': '48',
      '96': '96',
      '128': '128',
      '160': '160',
      '208': '208',
      '240': '240',
      '288': '288',
      '448': '448'
    },
  interactive: true,
  lineHeight: {
      '16': '16',
      '24': '24',
      '32': '32'
    },
  nowrap: true,
  overshootNone: true,
  raised: true,
  shrinkable: true,
  spanAll: true,
  sunken: true
}

export type Fw = typeof fw;

/**
 * Make sure the class and ui attributes are defined in fw.css.
 *
 * @reference https://design.funkwhale.audio/#/workspace/582e7be1-0cc7-11ed-87a1-ae44a720651d/e3a00150-0f5e-11ed-adb9-fff9e854a67c?page-id=63cce0e0-1a5f-11ed-8551-a35b3c702efa
 */
export type WithClass<C extends {
    align? : Align
    color? : Color
    font? : Font
    layout? : Layout
    shape? : Shape
}, T extends Partial<Ui>>= {
  class?: EmptyIsUndefined<Trim<
  `${
      ToString<C['align']>
    }${
      ToString<C['color']>
    }${
      ToString<C['font']>
    }${
      ToString<C['layout']>
    }${
      ToString<C['shape']>
    }`
  >>
} & T

type ToString<T extends string | undefined> = T extends string ? `${T} ` : ''

type EmptyIsUndefined<T extends string> = T extends '' ? undefined : T

export default fw
